import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gap-2 justify--end" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }

import { getCurrentInstance, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { FormMeta } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  props: {
  formMeta: {
    type: Object as () => FormMeta<any>,
    required: true
  }
},
  emits: ['save', 'cancel'],
  setup(__props) {





const action = ref('form.new');

onMounted(() => {
  const route = useRoute();
  if (route.name) {
    action.value = route.name.toString();
  } else {
    action.value = 'form.new';
  }
});

const emit = getCurrentInstance()?.emit;

const save = async function() {
  if (emit) {
    emit('save');
  }
};

const cancel = function() {
  if (emit) {
    emit('cancel');
  }  
};


return (_ctx: any,_cache: any) => {
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_navbar = _resolveComponent("va-navbar")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createBlock(_component_va_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_va_card_title, { class: "flex xs12 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_va_navbar, {
            color: "info",
            shape: "",
            class: "mb-2"
          }, {
            left: _withCtx(() => [
              _createVNode(_component_va_navbar_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("h3", {
                    class: "display-3",
                    style: _normalizeStyle({
                'color': 'var(--va-white)',
              })
                  }, _toDisplayString(_ctx.$t(`menu.${action.value}`)), 5)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_va_card_content, { class: "pa-2" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(_component_va_card_actions, {
        align: "stretch",
        vertical: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "actions"),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_va_button, {
                class: "px-4",
                color: "success",
                icon: "fas fa-save",
                disabled: !__props.formMeta.dirty,
                onClick: save
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_va_button, {
                class: "px-2",
                color: "danger",
                icon: "fas fa-close",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.cancel')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})